"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.useBackorderDelayCancel = void 0;
var _logger = require("@ori/logger");
var _react = require("react");
var _contexts = require("../../contexts");
var _types = require("../../types");
var _utils = require("../../utils");
const useBackorderDelayCancel = (props)=>{
    const logger = (0, _logger.useLogger)('useBackorderDelayCancel');
    const { setLoadingItem } = (0, _contexts.useBasketContext)();
    const { itemCode, lineNumber, placement, requestedQuantity, handleFeedbackOpen } = props;
    // unreserve
    const handleCancelBackorderDemand = (0, _react.useCallback)(async ()=>{
        try {
            await (0, _utils.cancelBackorderDemand)(lineNumber);
        } catch (error) {
            (0, _utils.showErrorNotification)();
            if (error instanceof Error) {
                logger.error(error);
            } else {
                const newError = new Error('handleCancelBackorderDemand Error', {
                    cause: error
                });
                logger.error(newError);
            }
        }
    }, [
        lineNumber,
        logger
    ]);
    const onCancelBackorderDemand = (0, _react.useCallback)(async ()=>{
        await handleCancelBackorderDemand();
    }, [
        handleCancelBackorderDemand
    ]);
    // delayBackorder
    const handleDelayBackorder = (0, _react.useCallback)(async ()=>{
        try {
            setLoadingItem(lineNumber);
            await (0, _utils.updateBasketItem)({
                itemCode,
                lineNumber,
                placement,
                previousQuantity: requestedQuantity,
                quantity: 0
            });
        } catch (error) {
            (0, _utils.showErrorNotification)();
            if (error instanceof Error) {
                logger.error(error);
            } else {
                const newError = new Error('handleDelayBackorder Error', {
                    cause: error
                });
                logger.error(newError);
            }
        } finally{
            setLoadingItem(-1);
        }
        if (handleFeedbackOpen) {
            handleFeedbackOpen(_types.FeedbackNotificationType.Reserve);
        }
    }, [
        handleFeedbackOpen,
        itemCode,
        lineNumber,
        logger,
        placement,
        requestedQuantity,
        setLoadingItem
    ]);
    const onDelayBackorder = (0, _react.useCallback)(async ()=>{
        await handleDelayBackorder();
    }, [
        handleDelayBackorder
    ]);
    return {
        onCancelBackorderDemand,
        onDelayBackorder
    };
};
exports.useBackorderDelayCancel = useBackorderDelayCancel;
